// src/shared/services/ServiceFactory.js
import MockService from './MockService';
import RealService from './RealService';
import LocalService from './LocalService';

class ServiceFactory {
    static getService() {
        console.log('ServiceFactory.getService called');
        console.log('REACT_APP_USE_MOCK_SERVICE:', process.env.REACT_APP_USE_MOCK_SERVICE);
        console.log('REACT_APP_USE_LOCAL_AUTH:', process.env.REACT_APP_USE_LOCAL_AUTH);

        if (process.env.REACT_APP_USE_MOCK_SERVICE === 'true') {
            console.log('Returning mock service')
            return new MockService();
        } else if (process.env.REACT_APP_USE_LOCAL_AUTH === 'true') {
            console.log('Returning local service')
            return new LocalService();
        }
        console.log('Returning real service (Cognito)');
        return new RealService();
    }
}

export default ServiceFactory;
